import { render } from "./WhatsAppMetaListPage.vue?vue&type=template&id=2df9f290&ts=true"
import script from "./WhatsAppMetaListPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsAppMetaListPage.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/whatsapp-meta/WhatsAppMetaListPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2df9f290"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2df9f290', __exports__)) {
    api.reload('2df9f290', __exports__)
  }
  
  module.hot.accept("./WhatsAppMetaListPage.vue?vue&type=template&id=2df9f290&ts=true", () => {
    api.rerender('2df9f290', render)
  })

}


export default __exports__